import { CRM, CRMListState } from '../../modules/crmSelector/action'
import type { ImageMapper } from '../../components/CRMSelector/CRMSelector'

export const mergeDefaultCRMListWithState = (
  defaultList: ImageMapper[],
  crmFromState: CRMListState['list'],
  handleClick: (e: CRM | string) => void
) => {
  const activeCRMList = ['hubspot', 'salesforce', 'connectwise']
  return defaultList.map(c => {
    const crm = crmFromState.filter(crm => crm.crm_type === c.crm_type)
    return crm.length > 0 && !c.oAuth
      ? {
          ...c,
          disabled: false,
          selected: false,
          handleClick: () => handleClick(crm[0]),
        }
      : c.oAuth && activeCRMList.includes(c.crm_type)
        ? {
            ...c,
            disabled: false,
            selected: false,
            handleClick: () => handleClick(c.crm_type),
          }
        : c
  }) as Array<ImageMapper>
}
